<template>
  <div>
    <product-detail v-if="productId != 0" :productId="productId"></product-detail>
    <common-problem v-if="commonProblemVisible"></common-problem>
  </div>
</template>

<script>
    import { queryChannelProductById } from '@/api/channel/channel.js'
    import ProductDetail from './product/productDetail.vue'
    import CommonProblem from './service/commonProblem.vue'
    export default {
        components: {
            ProductDetail,
            CommonProblem
        },
        data() {
            return {
                productId: 0,
                commonProblemVisible: false
            }
        },
        watch: {
            '$route' (to, from) {
                this.getData()
            }

        },
        created() {
            this.getData();
        },
        methods: {
            getData() {
                let id = window.location.href.substr(window.location.href.lastIndexOf('/') + 1, 2);
                if(id == 19 || id == 20) {//支持与服务
                    this.productId = 0;
                    this.commonProblemVisible = true;
                } else {//产品
                    this.commonProblemVisible = false;
                    //查询并传递产品id
                    queryChannelProductById(id).then(res => {
                        this.productId = res.data.list[0].productId;
                    })
                }
            }
        },
    }
</script>

<style lang="scss" scoped="scoped">

</style>